import { LockIcon, UnlockIcon } from "@chakra-ui/icons";
import { Flex, Heading, Button, Box, Text } from "@chakra-ui/react";
import { FC, useState } from "react";
import SwitchComponent from "../../atom/Switch/SwitchComponent";
import { primaryColor } from "../../../utils/colors";

interface SubmitItemHeaderProps {
  title: string | JSX.Element;
  isEditing?: boolean;
  setIsEditing?: (isEditing: boolean) => void;
  lastUpdateDate?: string;
  handleStateChange?: (isActive: boolean) => void;
  initialIsActive?: boolean;
}

const SubmitItemHeader: FC<SubmitItemHeaderProps> = ({
  title,
  isEditing,
  setIsEditing,
  lastUpdateDate,
  handleStateChange,
  initialIsActive = false,
}) => {
  const [isActive, setIsActive] = useState(initialIsActive);

  const handleSwitchToggle = (newValue: boolean) => {
    setIsActive((newValue) => !newValue);
    if (handleStateChange) {
      handleStateChange(newValue);
    }
  };

  return (
    <Flex direction="row" justifyContent="space-between">
      <Flex justifyContent="space-between" alignItems="center" w="100%">
        <Flex gap="2.5" alignItems="center">
          <Heading>{title}</Heading>
          {handleStateChange && (
            <SwitchComponent
              onChange={handleSwitchToggle}
              color={primaryColor}
              isActive={isActive}
              value={isActive}
            />
          )}
        </Flex>
        {lastUpdateDate && (
          <Box>
            <Text fontWeight="bold">última alteração:</Text>
            <Text>10/10/2024, 10:10</Text>
          </Box>
        )}
      </Flex>
      {isEditing !== undefined &&
        (!isEditing ? (
          <Box>
            <Button
              variant="primary"
              onClick={() => setIsEditing && setIsEditing(true)}
              leftIcon={<UnlockIcon />}
            >
              Desbloquear edição
            </Button>
          </Box>
        ) : (
          <Box>
            <Button
              variant="secondary"
              onClick={() => setIsEditing && setIsEditing(false)}
              leftIcon={<LockIcon />}
            >
              Bloquear edição
            </Button>
          </Box>
        ))}
    </Flex>
  );
};

export default SubmitItemHeader;
